import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import MaterialTable from 'material-table';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const EventsMeasurements = ({ externalData }) => {
  const { t } = useTranslation();

  const rows = React.useMemo(() => {
    let arrayRows = [];
    if (!externalData || !externalData.Objetivo) return [];

    let evento = externalData.Objetivo.Eventos;
    let totalMediciones = externalData.Objetivo.total_mediciones;

    if (evento && evento.length > 0) {
      Object.keys(evento).map((key) => {
        let rows = {};
        rows['paso'] = evento[key]['id'][0]['paso_nombre'];
        rows['cantidad'] = evento[key]['cantidad'];
        rows['codigo'] = evento[key]['eventos'][0]['nombre'];

        if (totalMediciones) {
          totalMediciones.forEach(function (value) {
            if (
              evento[key]['id'][0]['paso_nombre'] == Object.entries(value)[0][0]
            ) {
              rows['porcentaje'] = (
                (evento[key]['cantidad'] / Object.entries(value)[0][1]) *
                100
              ).toFixed(2);
            }
          });
        }
        arrayRows.push(rows);
        return null;
      });
    }
    return arrayRows;
  });

  return (
    <div style={{ maxWidth: '100%' }}>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('measurements.events-measurements.table.header.step'),
            field: 'paso',
          },
          {
            title: t('measurements.events-measurements.table.header.event'),
            field: 'codigo',
          },
          {
            title: t(
              'measurements.events-measurements.table.header.total-monitoring'
            ),
            field: 'cantidad',
          },
          {
            title: t(
              'measurements.events-measurements.table.header.percentage'
            ),
            field: 'porcentaje',
          },
        ]}
        data={rows}
        title=" "
        localization={t('measurements.events-measurements.table.localization', {
          returnObjects: true,
        })}
        options={{
          grouping: true,
        }}
      />
    </div>
  );
};

export default EventsMeasurements;
